import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'wsm-error-boundary';
import WebIntegrationPlaceholder from './WebIntegrationPlaceholder';

const WebIntegrationListingsPlaceholder = ({
	location,
	isGridLayout,
	forwardedRef
}) => {
	const classNames = [
		'vehicle-card',
		'placeholder-card',
		// 'vehicle-card-detailed', // WIAPI will add this if the card needs to be rendered
		isGridLayout ? null : 'vehicle-card-horizontal'
	];
	return (
		<ErrorBoundary newRelicPageAction="ws-inv-listing error boundary: WIAPI Listings placeholder location error">
			<WebIntegrationPlaceholder
				location={location}
				classNames={classNames}
				tagName="li"
				forwardedRef={forwardedRef}
			/>
		</ErrorBoundary>
	);
};

const ReferencedWebIntegrationListingsPlaceholder = React.forwardRef(
	(props, ref) => {
		return (
			<WebIntegrationListingsPlaceholder {...props} forwardedRef={ref} />
		);
	}
);

WebIntegrationListingsPlaceholder.propTypes = {
	location: PropTypes.string.isRequired,
	isGridLayout: PropTypes.string.isRequired,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	])
};

export default ReferencedWebIntegrationListingsPlaceholder;
